import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import SocialIAAMarketplaceFeatures from "./SocialIAAMarketplaceFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import SocialIAAMarketplaceBenefits from "./SocialIAAMarketplaceBenefits";
import "./SocialIAAMarketplace.css"
// Main component for SocialIAAMarketplace
export default function SocialIAAMarketplace() {
  // Overview Data
  const data1 = [
    "Farming Machinery Investment: Enables investors to fund the acquisition and utilization of farming equipment, supporting the agricultural sector.",
    "Processing Machinery Investment: Allows investors to finance the purchase and operation of machinery used for processing agricultural products.",
  ];
  
  const data2 = [
    "Agri Asset Investment: Provides investment opportunities in agricultural assets such as land, livestock, equipment, and infrastructure.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="social-iaa-marketplace-bg"
        bannerTitle={["Social IAAMarketplace"]}
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="SIM" />

      {/* Overview Feature Section*/}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Features & Benefits Section*/}
      <SocialIAAMarketplaceFeatures />
      <SocialIAAMarketplaceBenefits />
    </>
  );
}

